import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../../configuration/setup/store';
import { useAppSelector } from '../../configuration/setup/hooks';

type FleetGroupFilterState = {
    accountId?: string;
    selectedTagIds: string[];
};

const initialState: FleetGroupFilterState = {
    accountId: undefined,
    selectedTagIds: [],
};

export const fleetGroupFilterSlice = createSlice({
    name: 'fleetGroupFilter',
    initialState,
    reducers: {
        fleetGroupFilterAccountChanged: (state, action: PayloadAction<string | undefined>) => {
            state.accountId = action.payload;
            state.selectedTagIds = [];
        },
        fleetGroupFilterSelectionLoaded: (state, action: PayloadAction<string[]>) => {
            state.selectedTagIds = action.payload;
        },
        fleetGroupFilterSelectionChanged: (state, action: PayloadAction<string[]>) => {
            state.selectedTagIds = action.payload;
        },
    },
});

export const { fleetGroupFilterAccountChanged, fleetGroupFilterSelectionChanged, fleetGroupFilterSelectionLoaded } =
    fleetGroupFilterSlice.actions;

export const getFleetGroupFilterAccountId = (state: RootState) => state.fleetGroupFilter.accountId;
export const getSelectedFleetGroupTagIds = (state: RootState) => state.fleetGroupFilter.selectedTagIds;

export const useSelectedFleetGroupTagIds = () => useAppSelector(getSelectedFleetGroupTagIds);

export default fleetGroupFilterSlice.reducer;
